import { dateOnlyToDate } from "@/lib/format";
import type { PendingAttendanceWorker } from "../types";

export const PENDING_DATE_PARAM = "date";

export function pendingBannerText(count: number): string {
	const days = count === 1 ? "1 dia" : `${count} dias`;
	return `${days} sem preenchimento de ponto nos últimos 14 dias`;
}

export function firstPendingDate(
	workers: PendingAttendanceWorker[],
): string | undefined {
	let first: string | undefined;
	for (const item of workers) {
		for (const date of item.dates) {
			if (first === undefined || date < first) first = date;
		}
	}
	return first;
}

export function pendingFillPath(obraKey: string, date?: string): string {
	const base = `/${obraKey}/equipe`;
	if (!date) return base;
	const params = new URLSearchParams({ [PENDING_DATE_PARAM]: date });
	return `${base}?${params.toString()}`;
}

export function pendingDateParam(params: URLSearchParams): string | undefined {
	const value = params.get(PENDING_DATE_PARAM)?.trim();
	return value && dateOnlyToDate(value) ? value : undefined;
}
